module.exports = __webpack_public_path__ + "static/media/model-mission-3.be038dfc.png";